var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37367 2.39236C4.43951 2.31323 4.56179 2.31323 4.62763 2.39236L7.12939 5.39935C7.21793 5.50577 7.14157 5.66634 7.00241 5.66634H1.99889C1.85973 5.66634 1.78337 5.50577 1.87191 5.39935L4.37367 2.39236Z",
    fill: "#4891FF",
    stroke: "#4891FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrowUp);
export default __webpack_public_path__ + "static/media/small-arrow-up.e2eb55dc94d037c53abf2c96d997f02c.svg";
export { ForwardRef as ReactComponent };